(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.applyStickyType();

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    applyStickyType() {
      /* Ban-133: the theme setting on every screen size. Ban-149 (anh 24/10): except product pages, every screen size:
         the header scrolls away with the page and does not come back on scroll up (like Macorner, Wanderprints,
         Pawfect House); the back-to-top arrow (global.js) is the way back up there. */
      this.stickyType = document.body.classList.contains('product') ? 'none' : this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.header.classList.remove('shopify-section-header-hidden', 'animate', 'ezh-mini');
      this.header.classList.toggle('shopify-section-header-sticky', this.headerIsAlwaysSticky);
      /* Ban-158 (anh 24/10 18:12): "On scroll up", computers (>= 990px, CSS in ez-mega-menu.css), pages other than
         product pages: what comes back on scroll up is a compact 64px bar (small logo, search, cart) instead of the
         whole 154px header. Class .ezh-mini from the first hide until back at the top (reset). */
      this.miniOnScrollUp = this.stickyType === 'on-scroll-up';
    }

    setHeaderHeight() {
      /* Ban-158: the height of the header itself (this element), without the announcement bar above it and measured
         full size (not the 64px compact bar): Dawn's hidden state adds --ezab-h, the compact bar keeps this height
         for the section so nothing under it moves */
      const mini = this.header.classList.contains('ezh-mini');
      if (mini) this.header.classList.remove('ezh-mini');
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      if (mini) this.header.classList.add('ezh-mini');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      /* Ban-132: while the phone search (ez-search, full screen) or a drawer is open the page underneath must not move
         the header (iPhone still scrolls the page under a fixed panel: the search box shook and the caret lagged) */
      if (document.body.classList.contains('ezs-open-body') || document.body.classList.contains('overflow-hidden')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop < this.currentScrollTop && this.header.classList.contains('ezh-mini')) {
        /* Ban-158: scrolling up into the header's own space: the full header again (no blank band under the 64px bar) */
        requestAnimationFrame(() => this.header.classList.remove('ezh-mini'));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.stickyType === 'none') return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      /* Ban-158: compact bar from here on; "animate" off so the next reveal slides the bar in again */
      if (this.miniOnScrollUp) this.header.classList.add('ezh-mini');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.stickyType === 'none') return;
      if (this.miniOnScrollUp) this.header.classList.add('ezh-mini');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'ezh-mini');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      /* Ban-132: this header has no Dawn search modal (search = ez-search): it used to throw on every scroll-down */
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
